import { InstructorDashboard } from "apiEndPoints";
import { logger } from "utils";
import APIrequest from "../../axios";
// InstructorDashboard contains functions to interact with the dashboard-related APIs for the admin module.
// Each function corresponds to a specific API endpoint for tasks such as fetching Dashboard Count etc.
export const InstructorDashboardService = {

  /**
   * Function for fetching Dashboard Count.
   * @returns {Promise<Object>} - A promise that resolves to the response from the Dashboard Count API.
   */
  getDashboardService: async () => {
    try {
      const payload = {
        ...InstructorDashboard.getInstructorDashboard,
      };

      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
  /**
   * Function for fetching Pie chart data Count.
   * @returns {Promise<Object>} - A promise that resolves to the response from the Pie chart data Count API.
   */
  getPieChartService: async () => {
    try {
      const payload = {
        ...InstructorDashboard.getAdminPieChartData,
      };

      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },

  /**
   * Function for fetching line graph data Count.
   * @returns {Promise<Object>} - A promise that resolves to the response from the line graph data Count API.
   */
  getLineGraphService: async (queryParams) => {
    try {
      const payload = {
        ...InstructorDashboard.getAdminLineGraphData,
        queryParams,
      };

      return await APIrequest(payload);
    } catch (err) {
      logger(err);
      throw err;
    }
  },
};
